import { render } from "./px-navigation-tab.vue?vue&type=template&id=246919ae&scoped=true&ts=true"
import script from "./px-navigation-tab.vue?vue&type=script&lang=ts"
export * from "./px-navigation-tab.vue?vue&type=script&lang=ts"

import "./px-navigation-tab.vue?vue&type=style&index=0&id=246919ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246919ae"]])

export default __exports__